export const fonts = {
  body: '"Cera Compact Pro Demo", sans-serif',
  heading: '"Cera Pro", sans-serif',
};

export const fontSizes = {
  body: "18px",
  heading: "28px",
  subheading: "20px",
  label: "14px",

  huge: "26px",
  large: "20px",
  medium: "16px",
  small: "14px",
  xSmall: "12px",
  display: {
    huge: "60px",
    large: "52px",
    medium: "40px",
    small: "32px",
    xSmall: "20px",
  },
};

export const fontWeights = {
  bold: 600,
  regular: 400,
  display: {
    bold: 700,
    regular: 500,
  },
};

export const lineHeights = {
  huge: "32px",
  large: "28px",
  medium: "22px",
  small: "20px",
  xSmall: "16px",
  display: {
    huge: "64px",
    large: "56px",
    medium: "48px",
    small: "40px",
    xSmall: "26px",
  },
};

export const letterSpacings = { heading: "1px", body: "0.2px" };
